import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { NiceSelectModule } from "ng-nice-select";

import { OrdersRoutingModule } from './orders-routing.module';
import { SharedModule } from '@teem/shared/shared.module';
import { CoreModule } from '@teem/core/core.module';

import { OrdersComponent } from './orders.component';
import { OrderListComponent } from './order-list/order-list.component';
import { NewOrderListComponent } from './new-order-list/new-order-list.component';
import { OrderDetailComponent } from './order-detail/order-detail.component';
import { RejectionReasonComponent } from './modals/rejection-reason/rejection-reason.component';
import { OrderHistoryComponent } from './modals/order-history/order-history.component';
import { ScheduledComponent } from './modals/scheduled/scheduled.component';
import { OrderOtoComponent } from './modals/order-oto/order-oto.component';

@NgModule({
  declarations: [
  	OrdersComponent,
    OrderDetailComponent,
    OrderListComponent,
    NewOrderListComponent,
    RejectionReasonComponent,
    OrderHistoryComponent,
    ScheduledComponent,
    OrderOtoComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
		ReactiveFormsModule,
    CoreModule,
    SharedModule,
    NgxPaginationModule,
    NiceSelectModule,
    OrdersRoutingModule
  ]
})
export class OrdersModule { }
